import React, { useActionState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { authApiUrl } from "~/constants";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUser, userLoaded, userLoggedOut } from "~/slices/userSlice";
import type { AppDispatch, RootState } from "~/store";
import LoginWrapper from "~/components/LoginWrapper";
import BiaIcon from "~/ui/3dbiaUI/BiaIcon/BiaIcon";
import Flex from "~/components/Flex";
import RoleSelection from "~/containers/RoleSelection";
import BiaSpinner from "~/ui/3dbiaUI/BiaSpinner/BiaSpinner";
import { signOutThunk } from "~/thunks/authThunks";
import type { CurrentUser } from "~/types/roles";
import RoleTypesIds from "~/containers/App/RoleTypes";
import { createThunk } from '~/thunks/createThunks';
import { convertToMySqlDateFormat } from "~/utils/utils";

export default function SignIn(): React.JSX.Element {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const currentUser = useSelector(selectCurrentUser);
  const [user, setUser] = React.useState<CurrentUser | null>(null);

  useEffect(() => {
    console.log("currentUser", currentUser);
    if (currentUser) {
      if (currentUser.id === 469) {
        navigate(`/guests/assets`); // Redirect to the user's page
        return;
      } else {
        setUser(currentUser);

      }
      // else navigate(`/organizations/179`); // Redirect to the user's page
    }
  }, [currentUser, navigate]);
  const [error, submitAction, isPending] = useActionState(
    async (previousState: any, formData: FormData) => {
      const email = formData.get("email") as string | null;
      const password = formData.get("password") as string | null;

      if (!email || !password) {
        return "Email and password are required.";
      }

      const error = await signin(email, password);
      if (error) {
        return error;
      }

      return null;
    },
    null,
  );

  const signin = async (email: string, password: string) => {
    const response = await fetch(authApiUrl + "signin", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    });
    console.log({ response });
    if (response.ok) {
      const user = await response.json(); // Parse the response as JSON
      console.log(user); // Log the user object
      if (user.id === 469) {
        localStorage.setItem('currentUser', JSON.stringify(user)); // Store the token in localStorage
        navigate(`/guests/assets`); // Redirect to the user's page
        return;
      } else {
        setUser(user);

      }


      return null;
    }
    if (response.status === 400) {
      return "wrong password or user name";
    }

    try {
      const errorData = await response.json();
      if (typeof errorData?.message === "string") {
        return errorData.message;
      }
      if (typeof errorData?.error === "string") {
        return errorData.error;
      }
    } catch {
      // Fallback to generic message if response is not JSON.
    }

    return "Sign in failed. Please try again.";
  };

  const Input = ({
    label = "Email",
    type = "text",
    name = "email",
    required = true
  }) => {
    return (
      <Flex className="form-group pl-2" justify="start"
        style={{
          height: "3rem",
          backgroundColor: "rgb(241, 241, 241)",
        }}>
        <BiaIcon
          icon={name == "email" ? "envelope" : "lock"}
          className="form-icon color-secondary"
          style={{ marginRight: '8px' }}
        />
        <label htmlFor={name}>{label}:</label>
        <input type={type} id={name} name={name} required={required} placeholder={label}
          style={{
            width: "90%"
          }} />
      </Flex>
    );
  }
  const navigateByRole = (selectedRole: any) => {
    console.log("Navigating based on role:", selectedRole);
    if (!selectedRole) return;
    const isProvider = selectedRole.provider_name
    if (selectedRole.role_type_id === RoleTypesIds.SysAdmin) // Super admin
      navigate('/admin');
    else
    navigate(`/cesium?orgId=${selectedRole.organization_id}${isProvider ? '&provId=' + selectedRole.provider_id : ''}`);

  };
  const handleSelectedRole = async (role: any) => {
    console.log("Selected role:", role);
    if (!user) return;
    const response = await fetch(authApiUrl + "signin/token", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: user.id,
        email: user.email,
        role_id: role.role_id,
      }),
    });
    console.log({ response });
    if (response.ok) {
      const createdLoginRecord = await dispatch(createThunk({
            dataType: 'logins',
            data: {
              user_id: user.id,
              role_id: role.role_id,
              login_time: convertToMySqlDateFormat(new Date()),
            },
        })).unwrap();
      console.log("Created login record:", createdLoginRecord);
      const token = await response.text();
      const useWithToken = {
        ...user,
        token
      }
      // user.token = token; // Set the token on the user object
      dispatch(userLoaded({
        user: useWithToken,
        role: role,
        createdLoginId: createdLoginRecord.data.id
        
      }))
      navigateByRole(role);
      return null;
    }
    // return await response.text();
  }
  return (
    <LoginWrapper pageTitle="Sign in">
      {isPending ? <BiaSpinner className="loading-spinner" /> : user ? (
        <RoleSelection
          user={user}
          onRoleSelected={handleSelectedRole}
          onLogout={() => {
            dispatch(signOutThunk({ navigate, reason: 'User logged out during role selection' }));
            setUser(null);
          }}
        />
      ) : (
        <form action={submitAction} className="form"
          style={{
            width: "100%",
            height: "30vh",
            margin: "0 auto",
            marginTop: "2rem !important",
            padding: '0 7rem'
          }}>
          <Input
            label="Email"
            type="email"
            name="email"
            required={true}
            
          />
          <Input
            label="Password"
            type="password"
            name="password"
            required={true}
          />
          <div className="buttons">
            <button type="submit" className="button bg-success color-white bold text-center justify-content-center">LOGIN</button>

          </div>
        </form>
      )}

      {error && <p className="error-message">{error}</p>}
    </LoginWrapper>
  );
}